import React from 'react';

export default function TransactionIcon() {
  return (
    <svg
      width="18"
      height="10"
      viewBox="0 0 22 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 1.25L11 11.25L21 1.25"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
